import Select from '../BaseSearch/src/select.js'

Select.install = Vue => {
  Vue.component(Select.name, Select)
}

export default Select
